import React from 'react';
import { FadeIn } from './FadeIn';
const categories = [{
  name: 'Hormonas',
  color: 'bg-rosa hover:bg-rosa/80'
}, {
  name: 'Menopausia',
  color: 'bg-lila hover:bg-lila/80'
}, {
  name: 'Cuerpo y autoestima',
  color: 'bg-durazno hover:bg-durazno/80'
}, {
  name: 'Salud emocional',
  color: 'bg-celeste hover:bg-celeste/80'
}, {
  name: 'Obesidad',
  color: 'bg-beige hover:bg-beige/80'
}, {
  name: 'Sexualidad',
  color: 'bg-rosa hover:bg-rosa/80'
}, {
  name: 'Autoconocimiento',
  color: 'bg-lila hover:bg-lila/80'
}, {
  name: 'Bienestar femenino',
  color: 'bg-durazno hover:bg-durazno/80'
}];
export function Categories() {
  return <section id="temas" className="py-24 bg-lila/30" data-id="element-40">
      <div className="max-w-5xl mx-auto px-6 md:px-12 text-center" data-id="element-41">
        <FadeIn data-id="element-42">
          <h2 className="font-serif text-3xl md:text-4xl text-texto mb-12" data-id="element-43">
            Temas que atraviesan la vida real
          </h2>
        </FadeIn>

        <div className="flex flex-wrap justify-center gap-4 md:gap-6" data-id="element-44">
          {categories.map((cat, index) => <FadeIn key={cat.name} delay={index * 0.05} direction="up" data-id="element-45">
              <button className={`px-6 py-3 md:px-8 md:py-4 rounded-full font-sans text-texto font-medium transition-all duration-300 shadow-sm hover:shadow-md ${cat.color}`} data-id="element-46">
                {cat.name}
              </button>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}